<h1 mat-dialog-title>{{ 'internalEquipmentEdit.calibrations.body.title'.concat(isEdit ? '.edit' : '.create') | translate }}</h1>
<form>

  <div fxLayout="column" mat-dialog-content [class]="getTheme()">
    <div fxLayout="row">
      <div fxFlex="50">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'internalEquipmentEdit.general.actionTypes.label' | translate }}</mat-label>
          <mat-select [(ngModel)]="data.item.actionType" name="idsActionHistorical" (selectionChange)="onChangeActionType()">
            @for (item of actionTypes; track item) {
              <mat-option checkboxPosition="before" [value]="item.id">
                {{ 'internalEquipmentEdit.'+ item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'internalEquipmentEdit.general.actionTypes.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    @if (data.item.actionType) {
      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
        <div fxFlex>
          <mat-form-field class="campoFormulario">
            <mat-label>{{ (data.item.actionType === 4 ? 'calibrateEquipmentEdit.general.protocolNum.label': 'calibrateEquipmentEdit.general.certificateNum.label') | translate }}</mat-label>
            <input matInput
              name="certificateNum" [(ngModel)]="data.item.certificateNum">
            <mat-error>
              {{ (data.item.actionType === 4 ? 'calibrateEquipmentEdit.general.protocolNum.error': 'calibrateEquipmentEdit.general.certificateNum.error') | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        @if (data.item.actionType === 4) {
          <div fxFlex>
            <mat-form-field class="campoFormulario">
              <input matInput placeholder="{{ 'calibrateEquipmentEdit.general.executionNum.label' | translate }}"
                name="certificateNum" [(ngModel)]="data.item.executionNum">
              <mat-error>
                {{ (data.item.actionType === 4 ? 'calibrateEquipmentEdit.general.executionNum.error': 'calibrateEquipmentEdit.general.certificateNum.error') | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
        <div fxFlex>
          <mat-form-field style="width: 95%;">
            <mat-label>{{ data.item.actionType === 1 ? ('calibrateEquipmentEdit.general.calibrateDate.label' | translate ):
              data.item.actionType === 2 ? ('calibrateEquipmentEdit.general.verificationDate.label' | translate ):
              data.item.actionType === 3 ? ('internalEquipmentEdit.general.maintenanceCalibrateDate.label' | translate ):
              data.item.actionType === 5 ? ('calibrateEquipmentEdit.general.characterizationDate.label' | translate ):
            data.item.actionType === 4 ? ('calibrateEquipmentEdit.general.qualificationDate.label' | translate ): '' }}</mat-label>
            <input matInput id="calibrationDate" [matDatepicker]="calibrateDate" name="calibrationDate" [ngModel]="data.item.calibrationDate"
              [max]="maxDateCalibration"
              (blur)="saveDate('calibrationDate', $event)" (dateChange)="saveDate('calibrationDate', $event)">
            <mat-datepicker-toggle matSuffix [for]="calibrateDate"></mat-datepicker-toggle>
            <mat-datepicker #calibrateDate >
            </mat-datepicker>
            <mat-error>
              {{ 'calibrateEquipmentEdit.general.calibrateDate.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex>
          <mat-form-field style="width: 95%;">
            <mat-label>{{ data.item.actionType === 1 ? ('calibrateEquipmentEdit.general.expirationDate.label' | translate ) :
              data.item.actionType === 2 ? ('calibrateEquipmentEdit.general.verificationExpirationDate.label' | translate ) :
              data.item.actionType === 3 ? ('calibrateEquipmentEdit.general.maintenanceExpirationDate.label' | translate ) :
              data.item.actionType === 5 ? ('calibrateEquipmentEdit.general.characterizationExpirationDate.label' | translate ) :
            data.item.actionType === 4 ? ('calibrateEquipmentEdit.general.qualificationExpirationDate.label' | translate) : '' }}</mat-label>
            <input matInput id="expirationDate" [matDatepicker]="expirationDate" name="expirationDate" [ngModel]="data.item.expirationDate"
              (blur)="saveDate('expirationDate', $event)" (dateChange)="saveDate('expirationDate', $event)">
            <mat-datepicker-toggle matSuffix [for]="expirationDate"></mat-datepicker-toggle>
            <mat-datepicker #expirationDate >
            </mat-datepicker>
            <mat-error>
              {{ 'calibrateEquipmentEdit.general.expirationDate.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    }

    @if (data.item.actionType) {
      <div fxFlex="100%">
        <mat-form-field class="campoFormulario" style="width: 100%">
          <mat-label>{{ 'externalCalibrates.notes.label' | translate }}</mat-label>
          <textarea rows="5" matAutosizeMinRows="5" matInput [(ngModel)]="data.item.notes"
          name="notes" style="resize: none;"></textarea>
        </mat-form-field>
      </div>
    }

    @if (data.item.actionType === 1 || data.item.actionType === 2) {
      <mat-tab-group (selectedTabChange)="onVariableTabChange($event)">
        @for (variable of data.item.variables; track variable; let indexVariable = $index) {
          <mat-tab style="min-height: 50vh;"
            label="{{'variable.' + variable.variableTranslation | translate }}">
            <div fxLayout="row">
              <div fxFlex="33" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.unit.label' | translate }}</mat-label>
                  <mat-select name="unit{{variable.idVariable}}" [(ngModel)]="variable.idUnit" required
                    (selectionChange)="onUnitChange(indexVariable, $event)">
                    @for (item of variableUnits; track item) {
                      <mat-option [value]="item.id">
                        {{item.unit}}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.calibrationData.unit.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row">
              <div fxFlex></div>
              <div fxFlex="100">
                <div fxFlex="10">
                  <button mat-raised-button (click)="newValueRow(indexVariable)" color="accent">
                  {{ 'button.new' | translate }}</button>
                </div>
                @if (showUploadMass()) {
                  <div fxFlex="0.5"></div>
                }
                @if (showUploadMass()) {
                  <div fxFlex="12">
                    <button mat-raised-button color="accent" (click)="fileInputBalaceMass.click()"
                      matTooltip="{{  'button.upload' | translate }}">
                      <mat-icon>cloud_upload</mat-icon>
                      {{ 'button.upload' | translate }}
                    </button>
                    <input accept=".xlsx, .xls," hidden type="file" (change)="uploadMassiveBalanceMass(indexVariable, $event)"
                      #fileInputBalaceMass>
                  </div>
                }
                <div fxFlex="0.5"></div>
                @if (data.isBalance) {
                  <div fxFlex="30">
                    <button mat-raised-button color="primary" (click)="downloadBalanceMass()"
                      matTooltip="{{  'button.download-template' | translate }}">
                      {{ 'button.download-template' | translate }}
                      <mat-icon>cloud_download</mat-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
            <table #valuesTable mat-table [dataSource]="variable.values" style="width: 100%;">
              <!-- Number Column -->
              <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
              </ng-container>
              <!-- idMass Column -->
              @if (data.isBalance) {
                <ng-container matColumnDef="idMass">
                  <th mat-header-cell *matHeaderCellDef>
                  {{ 'calibrateEquipmentEdit.asLeft.cols.idMass.label' | translate }} </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{ element.idMass ? element.idMass : '-'}} </td>
                </ng-container>
              }
              <!-- ParticlesSize Column -->
              @if (data.isParticles) {
                <ng-container matColumnDef="particlesSize">
                  <th mat-header-cell *matHeaderCellDef>
                  {{ 'calibrateEquipmentEdit.asLeft.cols.particlesSize.label' | translate }} </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{ element.particlesSize ? element.particlesSize : '-'}} </td>
                </ng-container>
              }
              <!-- Point Column -->
              <ng-container matColumnDef="point">
                <th mat-header-cell *matHeaderCellDef>
                {{ 'calibrateEquipmentEdit.asLeft.cols.point.label' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.annotation ? element.point + " (·)" : element.point }} </td>
              </ng-container>
              <!-- Average Column -->
              <ng-container matColumnDef="average">
                <th mat-header-cell *matHeaderCellDef>
                {{ data.isBalance ? ('calibrateEquipmentEdit.asLeft.cols.physical.label' | translate) : ('calibrateEquipmentEdit.asLeft.cols.average.label' | translate) }} </th>
                <td mat-cell *matCellDef="let element">
                  <span [matTooltip]="data.isBalance ? element.pattern : element.average">
                    {{ data.isBalance ? element.pattern : element.average }}
                  </span>
                </td>
              </ng-container>
              <!-- Correction Column -->
              <ng-container matColumnDef="correction">
                <th mat-header-cell *matHeaderCellDef>
                {{ 'calibrateEquipmentEdit.asLeft.cols.correction.label' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.correction | number:'1.' + getDecimalsPattern(element.pattern) + '-' +
                  getDecimalsPattern(element.pattern) }}
                </td>
              </ng-container>
              <!-- U Column -->
              <ng-container matColumnDef="U">
                <th mat-header-cell *matHeaderCellDef>
                {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.uncertainty">
                    {{ element.uncertainty | smartNumber }}
                  </span>
                </td>
              </ng-container>
              <!-- Button edit Column -->
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button mat-icon-button (click)="editValueRow(indexVariable, i)">
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <!-- Button delete Column -->
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button mat-icon-button (click)="deleteValueRow(indexVariable, i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="data.isBalance ? valuesBalanceCols : (isParticles ? valuesParticlesCols : valuesCols)"></tr>
              <tr mat-row *matRowDef="let row; columns: data.isBalance ? valuesBalanceCols : (isParticles ? valuesParticlesCols : valuesCols)"></tr>
            </table>
            @if (variable.values?.length == 0) {
              <div>
                {{ 'common.noResults' | translate }}
              </div>
            }
          </mat-tab>
        }
      </mat-tab-group>
    }
    <div>
      <button mat-raised-button (click)="uploadCertificate.click()" color="accent">
      {{ 'button.upload-certificate' | translate }}</button>

      <div fxFlex="5px"></div>
      @if (data.item.id != null && data.item.idDocument != null) {
        <button mat-raised-button
        (click)="downloadCertificateEquipment()" color="accent">{{ 'button.download-certificate' | translate }}</button>
      }
      @if (data?.item?.uploadFile) {
        <span style="margin: 10px;">Archivo Adjunto: {{data?.item?.uploadFile?.name}}</span>
      }
      <input accept="application/pdf" hidden type="file" (change)="uploadCertificateToEquipment($event)"
        #uploadCertificate>
    </div>


  </div>
  <div mat-dialog-actions [class]="getTheme()">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>
    {{!isEdit ? ('button.add' | translate): ('button.save' | translate) }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>